export default __webpack_public_path__ + "static/demolition-contractors-banner-13048b5328be4b2493531ae0ce9e5530.jpg";